/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useCallback, useState } from 'react'
import { useDropzone } from 'react-dropzone'
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
// import OutlineButton from '../MUICustomButton/OutlineButton';
// import GradientButton from '../MUICustomButton/GradientButton';
import RequestDetailsForm from './RequestDetailsForm';
import CSVMapping from './CSVMapping';
import { useNavigate } from 'react-router-dom';

const steps = ['Request details', 'CSV mapping'];

interface RequestDataProps {
    "dataAnalystUserID": number;
    "requestID": string;
    "requestName": string;
    "requestDate": string;
    "workStartDate": string;
    "clientID": number;
    "clientName": string;
    "jobTypeID": number;
    "projectName": string;
    "projectTypeID": number;
    "clientProvidedFile": number;
    "folderName": string;
    "fileName": string;
    "source_NPI_FieldName": string;
    "source_FirstName_FieldName": string;
    "source_LastName_FieldName": string;
    "source_Address1_FieldName": string;
    "source_Address2_FieldName": string;
    "source_City_FieldName": string;
    "source_State_FieldName": string;
    "source_Zip_FieldName": string;
    "source_Phone_FieldName": string;
    "source_StateLicense_FieldName": string;
    "source_MENumber_FieldName": string;
    "source_DEANumber_FieldName": string;
    "provID_FieldName": string;
    "specID_FieldName": string;
    "nameParser_FullName_FieldName": string;
    "userId": number;
  }

function NewRequestImport(): JSX.Element {

    const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
    const [requestData, setRequestData] = useState<RequestDataProps>()

    const navigate = useNavigate();

    const onDrop = useCallback((acceptedFiles: any) => {
        console.log(acceptedFiles)
        setSelectedFiles(acceptedFiles)
        // Do something with the files
    }, [])

    const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop, accept: { "text/csv": [".csv"] }, maxFiles: 1 })

    const [activeStep, setActiveStep] = React.useState(0);
    // const [skipped, setSkipped] = React.useState(new Set<number>());

    // const isStepOptional = (step: number): boolean => {
    //     return step === 1;
    // };

    // const isStepSkipped = (step: number): boolean => {
    //     return skipped.has(step);
    // };

    const handleNext = (requestData: RequestDataProps): void => {
        console.log("RequestDataProps", requestData)
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
        setRequestData(requestData)
    };

    const handleBack = (): void => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    // const handleImportClick = (): void => {
    //     console.log(requestData)
    // }

    // const handleSkip = (): void => {
    //     if (!isStepOptional(activeStep)) {
    //         // You probably want to guard against something like this,
    //         // it should never occur unless someone's actively trying to break something.
    //         throw new Error("You can't skip a step that isn't optional.");
    //     }

    //     setActiveStep((prevActiveStep) => prevActiveStep + 1);
    //     setSkipped((prevSkipped) => {
    //         const newSkipped = new Set(prevSkipped.values());
    //         newSkipped.add(activeStep);
    //         return newSkipped;
    //     });
    // };

    const handleReset = (): void => {
        setActiveStep(0);
    };

    const handleBackClick = (): void => {
        navigate('/manage-jobs')
    }

    return (
        <React.Fragment>
            {/* <h2 className="text-2xl font-semibold text-title mb-[20px]">New Request</h2> */}
            <div className="flex justify-between items-center mb-[20px]">
                <div>
                    <h1 className="text-2xl text-title font-semibold">New Request</h1>
                </div>
                <div>
                    <button className="btn btn-sm h-[40px] w-[100px] normal-case flex text-14 border-primary border bg-white rounded-full text-primary items-center font-semibold py-[8px] px-[13px] hover:bg-[#ffaeb2] hover:border-primary" onClick={handleBackClick}><img src="/assets/images/red-arrow.svg" alt="arrow" width={9} height={8} className="mr-[5px] mt-[1px]" /> Back</button>
                </div>
            </div>
            <div className="mb-[30px] bg-white rounded-lg p-[20px] overflow-auto relative">
                <div className='dropzone'>
                    {
                        selectedFiles.length > 0 ?
                            selectedFiles.map(
                                acceptedFile =>
                                (
                                    <React.Fragment key={acceptedFile.name}>
                                        <span className='font-semibold'>{acceptedFile.name}</span>
                                        {activeStep === 0 && <a href='javascript:void(0)' onClick={() => {
                                            setSelectedFiles([])
                                        }} style={{ color: 'red', paddingTop: '10px' }}>Remove</a>
                                        }
                                    </React.Fragment>
                                )
                            ) :
                            <div {...getRootProps({})}>
                                <input {...getInputProps()} />
                                {
                                    isDragActive ?
                                        <p>Drop the files here ...</p> :
                                        <p>Drag and drop a valid CSV file here, or click to browse and select a file.</p>
                                }
                            </div>
                    }

                </div>

                <Box sx={{ width: '60%', marginTop: '40px', mx: 'auto' }}>
                    <Stepper activeStep={activeStep} alternativeLabel>
                        {steps.map((label) => {
                            const stepProps: { completed?: boolean } = {};
                            // if (isStepSkipped(index)) {
                            //     stepProps.completed = false;
                            // }
                            return (
                                <Step key={label} {...stepProps}>
                                    <StepLabel >{label}</StepLabel>
                                </Step>
                            );
                        })}
                    </Stepper>
                    {activeStep === steps.length ? (
                        <React.Fragment>
                            <Typography sx={{ mt: 2, mb: 1 }}>
                                All steps completed - you&apos;re finished
                            </Typography>
                            <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
                                <Box sx={{ flex: '1 1 auto' }} />
                                <Button onClick={handleReset}>Reset</Button>
                            </Box>
                        </React.Fragment>
                    ) : (
                        <React.Fragment>
                            {
                                activeStep === 0 &&
                                <div style={{ marginTop: '40px' }}>
                                    {/* @ts-ignore */}
                                    <RequestDetailsForm activeStep={activeStep} onNextClick={(requestData: RequestDataProps) => handleNext(requestData)} selectedFiles={selectedFiles} requestData={requestData}  />
                                </div>
                            }
                            {
                                activeStep === 1 &&
                                <div style={{ marginTop: '40px' }}>
                                    {/* @ts-ignore */}
                                    <CSVMapping activeStep={activeStep} onBackClick={handleBack} requestData={requestData} selectedFiles={selectedFiles} />
                                </div>
                            }

                            
                        </React.Fragment>
                    )}
                </Box>

            </div>
        </React.Fragment>
    )
}

export default NewRequestImport